import { ErrorBaseData } from '.'

export const kbaErrors: Record<string, ErrorBaseData> = {
  KbaAlreadyRegisteredException: {
    message: 'Kba já gerado',
    description: 'Já foi gerado um kba para este cpf. Verifique as informações e tente novamente',
  },
  KbaNotFoundException: {
    message: 'Kba não encontrado',
    description: 'Não foi encontrado um kba para este cpf. Verifique as informações e tente novamente',
  },
}
